const carMonitor = {
  systemsummary: {
    navigation: {
      sitemap: "Site Map"
    }
  },
  monitorinfo: {
    carStatus: {
      offonlinetimegreaterthan: "Offline time greater than",
      useageofvehicle: "Useage of vehicle",
      online: "Online",
      offline: "Offline",
      commercialvehicle: "Commercial-vehicle",
      testvehicle: "Test-vehicle",
      comparisonvehicle: "Comparison-vehicle",
      unlocated: "Unlocated",
      located: "Located",
      stopped: "Stopped",
      moving: "Moving",
      signaledcan: "Signaled",
      nonsignaledcan: "Non-signaled",
      days: "day",
      hours: "hr",
      minutes: "min",
      seconds: "sec",
      datasubmissiontime: "Time of datasubmission",
      lastonlinetime: "Last online time",
      GPSpositioning: "GPS status",
      whethermoving: "Whether moving",
      whetherhavecansignal: "Whether have can-signal",
      voltage:"Battery status",
      coolantTemporature:"Coolant Temperature",
      whetherterminalisonline: "Engine status",
      offonlinetime: "Offline time",
      vehiclecurrentposition: "Vehicle current position",
      failedtogetwebsocketaddress: "Failed to get websocket address",
      realTimeDialog: {
        carRealData: "Real-time Data",
        carRealBattery: "Current battery power (SOC)",
        lastdatasubmissiontime: "Final Data Time",
        vehicleTypeCode: "VehicleTypeCode",
        internalCode: "Batch lot",
        productmodel: " ProductModel",
        usearea: "UseArea",
        signalstrength: "SignalStrength",
        GPSmileage: "GPSMileage",
        CANData: "CAN Data",
        Speed: "Speed",
        No: "No",
        Yes: "Yes",
        gpsTime: "GPS Time",
        carLatPos: "Last reported location before vehicle offline",
        carRun: "Vehicle running data",
        isOnLine: "Engine realtime online"
      },
      area: "Province",
      model: "Model",
      search: {
        width1: "100",
        width2: "80",
        width3: "60",
        width4: "60"
      }
    }
  },
  plateNumber: "License plate",
  OBDwidth: "50px",
  logo: "Brand",
  carModel: "Model",
  series: "Series",
  tips: "Please enter",
  vehicleConfiguration: "Series",
  conditionMonitoring: "Condition monitoring",
  vehicle: {
    realtimeData: "Vehicle real-time parameters",
    width1: "175px",
    searchWidth: "90px",
    SOC: "Current battery level",
    yesonline: "Online",
    noonline: "not online",
    yes: "yes",
    no: "no",
    yesdriving: "travel",
    nodriving: "stop",
    yesCan: "Has CAN",
    noCan: "Without CAN",
    isonline: "Whether the terminal is online",
    lastActiveTime: "Last data reporting time",
    areaName: "applied area",
    gpsPosition: "Whether to locate",
    isdriving: "Whether to exercise",
    gpsMileage: "GPS mileage",
    gpsSpeed: "GPS speed",
    canHasData: "CAN data",
    realtimeError: "No data",
    speedCard: "speed",
    lastParames: "Last reported data before vehicle offline"
  },
  electric: {
    electricManage: {
      alarmrulesname: "Alarm name",
      rulestype: "Geofence type",
      creattime: "Creation time",
      starttime: "Start time",
      endtime: "End time",
      placeholder: "Placeholder",
      administrativeAreas: "Administrative Areas",
      polygon: "Polygon",
      circular: "Circular",
      outOf: "OutOf",
      alarmType: "Alarm type",
      speedThreshold: "Speed threshold",
      alarmVehicle: "No. of Vehicle ",
      description: "Description",
      createdby: "Created by",
      createdon: "Created time",
      deleteAlert: "Please select the item to delete",
      alert1: "Whether or not to delete",
      prompt: "Prompt",
      confirm: "Confirm",
      cancel: "Cancel",
      successfullyDelete: "Delete successfully",
      setCarAlert: "Please select the electronic fence rule",
      detailCarDialog: {
        vehicledetail: "Vehicle detail",
        licensePlate: "License plate",
        typename: "TypeName",
        batchcode: "Batch lot"
      },
      wlxq: "Details of Geofence",
      wlss: "Belongs to",
      wlxx: "Information of the Geofence",
      carTitle: "Vehicle",
      radius: "radius",
      createdByYou: "Created by you",
      readOnly: "No",
      editable: "Yes",
      readOnlyTip: "You don't have permission to operate this item",
      addVehicleTip: "You are going to add vehicles to your electronic fence",
      subCompany: "Sub Company",
      department: "Department",
      subUserTip: "You can create an electronic fence for your "
    },
    electricNotes: {
      licensePlate: "License plate",
      alarmType: "Alarm type",
      alarmTime: "Alarm time",
      starttime: "Alarm time",
      endtime: "End time",
      alarmrulesname: "Alarm name",
      address: "Alarm address",
      whetherended: "Whether ended",
      alarmMessage: "Message",
      fenceMessage: "Information of the fence",
      alarmCar: "Alarm message",
      outOf: "Drive out",
      overspeed: "Overspeed",
      unfinished: "Unfinished",
      finished: "Finished",
      alarmsubtype: "Alarmsub type",
      currentalarmspeed: "Current alarm speed",
      userName: "Mobile No",
      ruleName: "Geofence name",
      ruleType: "Rule type",
      status: "status",
      ending: "Has ended",
      noending: "Not over yet",
      width1: "90px",
      width2: "70px",
      width3: "90px",
      alarmDetail: "Electronic fence alarm details"
    }
  },
  terminalCommand: {
    commandName: "Command package name",
    startTime: "Start time",
    endTime: "End time",
    paramscount: "Number of commands",
    loginname: "Founder",
    createdon: "Creation time",
    commondStatus: "Command packet status",
    remark: "Remarks",
    function: "operating",
    see: "View",
    notperformed: "Not performed",
    Finishedperformed: "Finished",
    Inprogress: "In progress",
    add: "Create",
    data: "parameter",
    okBtn: "Confirm",
    cancleBtn: "Cancle",
    doubleClick: "Double click to operate",
    upload: "upload",
    setData: "Setting parameters",
    packetnameTips: "Please enter the command package name",
    addFuncTips: "Please add an action",
    addSuccess: "Added successfully",
    browse: "Browse",
    yes: "Yes",
    file: "file",
    explanation: "Explanation",
    checkFile: "Please select a file",
    versionnumber: "version number",
    uploadUrl: "Upload path",
    isSet: "Whether to set the default",
    dbcTips: "Please fill in the DBC storage path",
    regexText: "Please fill in the pkg storage path",
    such: "Such as",
    bitian: "This item is required",
    gxbun: "The item cannot be",
    success: "success",
    uploadSuccess: "File uploaded successfully",
    uploadFileTips: "Please select upload file",
    uploadFilereset: "This file has been uploaded. Please re select the uploaded file",
    uploadLoading: "File uploading",
    formate: "Please fill in the form correctly",
    width1: "100px",
    width2: "180px",
    width3: "80px",
    width4: "100px",
    width: "100px",
    searchWidth: {
      width1: "165px",
      width2: "80px"
    }
  },
  terminalBatch: {
    commandWdith: "160px",
    taskName: "Task Name",
    commandName: "Command package name",
    vin: "VIN code",
    loginname: "Founder",
    createtime: "Create time",
    paramscount: "Number of commands",
    yichexiao: "rescinded",
    notperformed: "Not performed",
    Inprogress: "In progress",
    Finishedperformed: "Finished",
    failedcount: "Execution failed",
    tingzx: "Suspend execution",
    weizhi: "unknown",
    see: "View task details",
    seeBatch: "View command package",
    function: "operating",
    add: "Add offline command task",
    selectCar: "Select vehicle",
    selectObd: "Select OBD device",
    import: "import",
    reset: "Reset",
    carMessage: "Vehicle information",
    okCheck: "Selected",
    numberCar: "cars",
    notCar: "No vehicle is currently selected",
    remark: "Remarks",
    okBtn: "Confirm",
    cancleBtn: "Cancle",
    tasknameTips: "Please enter task name",
    selectCarTips: "Please select the OBD device number",
    packetnameTips: "Please enter the command package name",
    addSuccess: "Added successfully",
    seeParames: "View command package parameters",
    data: "parameter",
    obdTaskDetail: "OBD upgrade task details",
    taskDetail: "Task command details",
    cartypeid: "Model name",
    carbatchid: "Project code",
    terminalcode: "Task terminal",
    online: "on-line",
    notOnline: "Not online",
    export: "export",
    allStatus: "Overall completion",
    ml: "command",
    mlParames: "Command parameters",
    wancheng: "Completion",
    selectName: "Select command name",
    width3: "80px",
    width4: "120px",
    searchWidth: {
      width1: "170px",
      width2: "90px",
      width3: "130px"
    },
    upgrade: "Upgrade package",
    createUpgrade: "Create upgrade package",
    HistoricalUpgrade: "Historical upgrade package",
    uploadFiles: "Upload files",
    version: "Version",
    versionDescription: "Version Description",
    historicalVersion: "Historical version",
    addObdTask: "Add OBD upgrade task",
    error: {
      message1: "Please enter the version number",
      message2: "Please select upload file",
      message3: "Please select historical version",
      message4: "Please upload the .bin file",
      message5:'Select an upgrade type'
    },
    sjtype:'Upgrade type',
    sjtype1:'Online UPGRADE of OBD',
    sjtype2:'Online Upgrade of vehicles'
  },
  terminalControl: {
    title: "Remote debugging",
    fileManagement: "Terminal file management",
    loadDir: "Load terminal directory",
    downloadFiles: "Download files",
    shellCommandTitle: "Shell command",
    shellCommand: "Command",
    implement: "Execute",
    res: "Return",
    downloadingData: "Downloading data...",
    systemPrompt: "System prompt"
  },
  trip: {
    starttime: "Start time",
    searchWidth: {
      width1: "50px"
    },
    startLngLat: "Beginning latitude and longitude",
    endttime: "End time",
    endLngLat: "End longitude and latitude",
    accelerate: "Number of rapid acceleration",
    slowdown: "Number of sharp deceleration",
    sharpturnCunt: "Number of sharp turns"
  }
}
export default carMonitor